import { LitElement, html, css } from 'lit'

class PagingContainer extends LitElement {
  #listContainer
  #button

  static properties = {
    visible: { type: Boolean, reflect: true },
    name: { type: String },
  }

  static styles = css`
    :host {
      margin-bottom: 30px !important;
    }
  `

  constructor() {
    super()
    this.#listContainer = document.getElementById(this.getAttribute('for'))
    this.#button = this.querySelector('button')
    this.#listContainer.addEventListener(
      'list-updated',
      this.handleListUpdate.bind(this)
    )
    this.#listContainer.addEventListener(
      'filter-update',
      this.handleFilterUpdate.bind(this)
    )
    this.#button.addEventListener('click', this.handleButtonClick.bind(this))
    if (!this.visible) {
      this.style.display = 'none'
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('visible')) {
      if (this.visible) {
        this.style.removeProperty('display')
      } else {
        this.style.display = 'none'
      }
    }
  }

  handleFilterUpdate(e) {
    let params = new URLSearchParams(window.location.search)
    params.delete(this.name)
    let url = new URL(window.location.href)
    url.search = params.toString()
    window.history.replaceState({}, '', url)
  }

  handleListUpdate(e) {
    this.visible = e.detail.count < e.detail.total
    this.#button.removeAttribute('aria-busy') 
  }

  handleButtonClick() {
    if (this.#listContainer.loading) {
      return
    }

    this.#button.setAttribute('aria-busy', 'true')
    
    let params = new URLSearchParams(window.location.search)
    let page = parseInt(params.get(this.name)) || 0
    params.set(this.name, page + 1)

    let url = new URL(window.location.href)
    url.search = params.toString()
    window.history.replaceState({}, '', url)

    this.#listContainer.dispatchEvent(
      new CustomEvent('paging-update', {
        bubbles: true,
        detail: { pageNo: page + 1 },
      })
    )
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('paging-container', PagingContainer)
